import { c as _c } from "react/compiler-runtime";
interface NeurosurgeryIconProps {
  size?: number;
  className?: string;
}
const NeurosurgeryIcon = t0 => {
  const $ = _c(7);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M14.4736 2.9502C11.9427 2.96527 9.56594 3.97832 7.78125 5.80273C5.99587 7.6272 5.01172 10.0499 5.01172 12.623C5.01173 12.9499 5.02884 13.276 5.06055 13.5957L3.1377 16.625C2.90818 16.9844 2.88819 17.4269 3.08398 17.8066C3.28068 18.1873 3.65207 18.4234 4.07617 18.4355L5.33789 18.4707V22.2227C5.33789 23.1322 5.90342 23.9601 6.74707 24.2822C8.17205 24.8242 10.4969 25.2049 13.4883 23.9521C13.7699 23.834 13.9038 23.5068 13.7881 23.2217C13.6722 22.9362 13.3495 22.7995 13.0674 22.917C10.4041 24.0322 8.37037 23.7043 7.13574 23.2344C6.72067 23.0754 6.44053 22.6692 6.44043 22.2227V17.9268C6.44043 17.6246 6.20337 17.3762 5.9043 17.3672L4.1084 17.3164C4.09367 17.316 4.08432 17.3113 4.07812 17.3066C4.07141 17.3016 4.06545 17.2948 4.06152 17.2871V17.2861C4.05122 17.2663 4.05227 17.2498 4.06445 17.2305V17.2295L6.09375 14.0352V14.0342C6.16315 13.9241 6.1929 13.7928 6.17676 13.6631C6.13561 13.3237 6.11523 12.9732 6.11523 12.6221C6.11528 7.93261 9.86978 4.09702 14.4814 4.06934C16.7211 4.05728 18.8448 4.94221 20.4531 6.56641C22.0614 8.18999 22.9469 10.3387 22.9482 12.6172C22.9496 15.2453 21.7871 17.6912 19.7588 19.3262C19.0355 19.9101 18.725 20.877 18.9658 21.79L19.7168 24.6348C19.7828 24.8838 20.0047 25.0483 20.248 25.0488V25.0498C20.2715 25.0498 20.2953 25.0481 20.3193 25.0449L20.3916 25.0303C20.6858 24.9501 20.8593 24.643 20.7812 24.3457L20.0293 21.501C19.9019 21.0175 20.0649 20.5079 20.4434 20.2021C22.7368 18.3531 24.0511 15.5884 24.0498 12.6172C24.0484 10.0392 23.0468 7.6086 21.2295 5.77344C19.412 3.93815 17.0095 2.93585 14.4736 2.9502Z" fill="currentColor" stroke="currentColor" strokeWidth="0.1" />;
    t7 = <path d="M8 11.7303H12.6842L13.9276 14.6316L16 8L17.6579 13.3882L18.9013 10.4868L19.7303 12.1447H23.4375" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t6;
    $[3] = t7;
  } else {
    t6 = $[2];
    t7 = $[3];
  }
  let t8;
  if ($[4] !== t3 || $[5] !== t5) {
    t8 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}{t7}</svg>;
    $[4] = t3;
    $[5] = t5;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  return t8;
};
export default NeurosurgeryIcon;